export default "__VITE_ASSET__BWGNmnb7__"